/* eslint-disable @typescript-eslint/no-explicit-any */

/**
 * TODO:
 * Schedule appointment for review.
 */

import {
	GET_FM_PARTNER_LIST_FOLLOWERS_FOLLOWERS,
	GET_FM_PARTNER_LIST_FOLLOWERS_PARTNERS,
	deletePartnerList,
	getFMPartnerList,
	getFMPartnerListFollowers,
	getFMPartnerListPartners,
	patchEditPartneList,
	postNewPartnerList
} from 'api'
import {
	Button,
	FmPartnerListTableFollowers,
	FmPartnerListTablePartners,
	Icon,
	Input,
	TailwindModal,
	Typography
} from 'components'
import { useSearchDebounce, useToast } from 'hooks'
import {
	EditPartnerListRequest,
	FMPartnerListFollowersResponse,
	FMPartnerListPartnersResponse,
	GenericModalProps,
	Icons,
	NewPartnerListRequest,
	TypographyTypes
} from 'interfaces'
import React, { useEffect, useState } from 'react'
import { useQuery } from 'react-query'
import Cookies from 'universal-cookie'

const MAX_SEARCH_LENGTH = 100

export const FmPartnerListsModal: React.FC<GenericModalProps<any>> = ({
	open,
	setOpen
}): JSX.Element => {
	const cookies = new Cookies()
	const userId = cookies.get('userId')
	const organizationId = cookies.get('organization_id')
	const [newListValue, setNewListValue] = useState('')
	const [search, setSearch] = useState('')
	const { inputSearch, handleChangeDebounce, resetInput } =
		useSearchDebounce('')
	const [dataSelected, setDataSelected] = useState<number[]>([])
	const [partnersPage, setPartnersPage] = useState(1)
	const [followersPage, setFollowersPage] = useState(1)
	const [listToDelete, setListToDelete] = useState<number | null>(null)
	const [listToEdit, setListToEdit] = useState<number>(0)
	const [isLoading, setIsLoading] = useState(false)
	const [isDeleting, setIsDeleting] = useState(false)
	const quantityInitPage = 10
	const [partnersTableList, setPartnersTableList] = useState(quantityInitPage)
	const [subscriptionsTable, setSubscriptionsTable] = useState(quantityInitPage)
	const {
		data: partnersData,
		isLoading: partnersIsLoading,
		refetch: partnersRefetch
	} = useQuery(
		[
			GET_FM_PARTNER_LIST_FOLLOWERS_PARTNERS,
			subscriptionsTable,
			{ page: partnersPage, search: inputSearch.trim(), userId, organizationId }
		],
		() =>
			getFMPartnerListPartners(organizationId, {
				page: partnersPage,
				search: inputSearch.trim(),
				size: subscriptionsTable
			})
	)

	const {
		data: followersData,
		isLoading: followersIsLoading,
		refetch: refetchFollowers
	} = useQuery(
		[
			GET_FM_PARTNER_LIST_FOLLOWERS_FOLLOWERS,
			followersPage,
			userId,
			organizationId,
			partnersTableList
		],
		() =>
			getFMPartnerListFollowers(
				organizationId,
				followersPage,
				'',
				partnersTableList
			)
	)

	const { data: partnerlistData } = useQuery(
		[
			GET_FM_PARTNER_LIST_FOLLOWERS_FOLLOWERS,
			listToEdit,
			userId,
			organizationId
		],
		() => getFMPartnerList(organizationId, listToEdit)
	)

	const { showToast } = useToast()

	const submitHandler = async (body: NewPartnerListRequest): Promise<void> => {
		setIsLoading(true)
		postNewPartnerList(organizationId, body)
			.then(response => {
				if (response) {
					showToast('Success', 'New list created successfully', 'success')
					refetchFollowers()
					partnersRefetch()
					setDataSelected([])
					setNewListValue('')
					setOpen(false)
				}
			})
			.finally(() => setIsLoading(false))
	}

	const submitHandlerEdit = async (
		body: EditPartnerListRequest
	): Promise<void> => {
		setIsLoading(true)
		patchEditPartneList(organizationId, listToEdit, body)
			.then(response => {
				if (response) {
					showToast('Success', 'List edit successfully', 'success')
					refetchFollowers()
					partnersRefetch()
					setDataSelected([])
					setNewListValue('')
					setOpen(false)
				}
			})
			.finally(() => setIsLoading(false))
	}

	const deleteList = async (listId: number): Promise<void> => {
		setIsDeleting(true)
		try {
			const res = await deletePartnerList(organizationId, listId)
			if (res !== null) {
				showToast('Deleted', 'List deleted successfully', 'success')
				setListToDelete(null)
				refetchFollowers()
			} else {
				showToast('Error', 'Error deleting list', 'error')
			}
		} finally {
			setIsDeleting(false)
		}
	}

	useEffect(() => {
		if (partnerlistData && listToEdit) {
			setNewListValue(partnerlistData.name)

			const filteredArray = partnerlistData.partners?.filter(
				partnerlistItem => {
					return partnersData?.items.some(
						partnersItem =>
							partnersItem.organization_partner_id ===
							partnerlistItem.organization_partner_id
					)
				}
			)

			const uniqueIds: any = []
			filteredArray?.forEach(item => {
				if (!uniqueIds.includes(item.organization_partner_id)) {
					uniqueIds.push(item.organization_partner_id)
				}
			})

			const selectedIds = uniqueIds ?? []
			setDataSelected(selectedIds)
		}
	}, [partnerlistData, listToEdit])

	const handleClick = (): void => {
		if (partnerlistData && listToEdit) {
			submitHandlerEdit({
				name: newListValue,
				organization_partner_ids: dataSelected
			})
		} else {
			submitHandler({
				name: newListValue,
				organization_partner_ids: dataSelected
			})
		}
	}
	return (
		<TailwindModal
			open={open}
			setOpen={setOpen}
			title="FM Partner Lists"
			className="md:w-[95vw] w-full p-4 rounded-[16px] h-[87vh]"
		>
			<div className="relative h-full">
				{listToDelete !== null && (
					<div className="absolute inset-0 z-10 flex items-center justify-center">
						<div className="bg-white rounded-[16px] p-6 w-[360px] flex flex-col items-center gap-4 shadow-boxSettings">
							<div className="w-[30px] h-[30px]">
								<Icon
									src={Icons.warning}
									fillPath
									className="text-blue-primary"
								/>
							</div>
							<Typography
								title="Delete Partner Lists"
								fontLeading="15/18"
								type={TypographyTypes.h3}
								className="text-blue-primary text-center"
							/>
							<Typography
								title="Are you sure you want to delete this Partner Lists"
								fontLeading="15/18"
								type={TypographyTypes.h3}
								className="!font-normal text-black-1 text-center"
							/>
							<div className="flex justify-center items-center gap-4">
								<Button
									label="Cancel"
									color="LavenderLight"
									disabled={isDeleting}
									onClick={() => setListToDelete(null)}
									className="!min-w-[unset] !py-3 !px-9"
								/>
								<Button
									disabled={isDeleting}
									onClick={() => deleteList(listToDelete)}
									className="!min-w-[unset] !py-3 !px-9"
								>
									<div className="flex items-center gap-2">
										{isDeleting && (
											<svg
												width="14"
												height="14"
												viewBox="0 0 16 16"
												fill="none"
												xmlns="http://www.w3.org/2000/svg"
											>
												<circle
													cx="8"
													cy="8"
													r="6"
													stroke="white"
													strokeWidth="2"
													strokeLinecap="round"
													strokeDasharray="28"
													strokeDashoffset="10"
													fill="none"
												>
													<animateTransform
														attributeName="transform"
														type="rotate"
														from="0 8 8"
														to="360 8 8"
														dur="0.8s"
														repeatCount="indefinite"
													/>
												</circle>
											</svg>
										)}
										<span>Continue</span>
									</div>
								</Button>
							</div>
						</div>
					</div>
				)}
				<div className="flex flex-col gap-6 w-full md:h-[calc(100%_-_134px)] h-[calc(100%_-_164px)] mt-4 overflow-y-auto">
					<Input
						name="message"
						title="New list name"
						placeholder="Text here"
						className="!w-full !p-[unset]"
						value={newListValue}
						onChange={event => setNewListValue(event.target.value)}
						maxLength={MAX_SEARCH_LENGTH}
						error={
							newListValue.length >= MAX_SEARCH_LENGTH
								? {
										message: `Maximum ${MAX_SEARCH_LENGTH} characters`,
										type: 'maxLength'
								  }
								: undefined
						}
						inputClassName="!p-[unset] !py-1 !px-2"
						inputFocus
					/>
					<Input
						name="search"
						placeholder="Search"
						className="!w-full !p-[unset]"
						onChange={e => {
							setSearch(e.target.value)
							handleChangeDebounce(e)
						}}
						rightIcon={Icons.cancel}
						rightClick={() => {
							resetInput()
							setSearch('')
						}}
						value={search}
						maxLength={MAX_SEARCH_LENGTH}
						inputClassName="!p-[unset] !py-1 !px-2"
						inputFocus
						error={
							search.length >= MAX_SEARCH_LENGTH
								? {
										message: `Maximum ${MAX_SEARCH_LENGTH} characters`,
										type: 'maxLength'
								  }
								: undefined
						}
						borderFull={false}
						search
					/>
					<div className="w-full flex gap-4 flex-col md:flex-row">
						<FmPartnerListTableFollowers
							data={followersData as FMPartnerListFollowersResponse | undefined}
							isLoading={followersIsLoading}
							className="basis-[50%]"
							page={followersPage}
							onDelete={setListToDelete}
							onEdit={setListToEdit}
							setPage={setFollowersPage}
							itemsShowing={partnersTableList}
							onShowingItemsChange={setPartnersTableList}
						/>
						<FmPartnerListTablePartners
							data={partnersData as FMPartnerListPartnersResponse | undefined}
							isLoading={partnersIsLoading}
							className="basis-[50%]"
							page={partnersPage}
							setPage={setPartnersPage}
							setDataSelected={setDataSelected}
							dataSelected={dataSelected}
							itemsShowing={subscriptionsTable}
							onShowingItemsChange={setSubscriptionsTable}
						/>
					</div>
				</div>
				<div className="flex justify-center items-center mt-4 gap-4 w-full md:flex-row flex-col-reverse">
					<Button
						label="Cancel"
						color="LavenderLight"
						onClick={() => setOpen(false)}
					/>
					<Button
						disabled={
							newListValue === '' || dataSelected.length === 0 || isLoading
						}
						onClick={() => handleClick()}
					>
						<div className="flex items-center justify-center gap-2">
							{isLoading && (
								<svg
									width="16"
									height="16"
									viewBox="0 0 16 16"
									fill="none"
									xmlns="http://www.w3.org/2000/svg"
								>
									<circle
										cx="8"
										cy="8"
										r="6"
										stroke="#17B3C5"
										strokeWidth="2"
										strokeLinecap="round"
										strokeDasharray="28"
										strokeDashoffset="10"
										fill="none"
									>
										<animateTransform
											attributeName="transform"
											type="rotate"
											from="0 8 8"
											to="360 8 8"
											dur="0.8s"
											repeatCount="indefinite"
										/>
									</circle>
								</svg>
							)}
							<span className="font-normal text-[15px] leading-[18px]">
								Save
							</span>
						</div>
					</Button>
				</div>
			</div>
		</TailwindModal>
	)
}
